import { advertisingQueries } from '@round/api';
import { useQuery } from '@tanstack/react-query';

const options = advertisingQueries.influencerPlan.options.detail;

type Config = Pick<ReturnType<typeof options>, 'enabled' | 'refetchOnWindowFocus'>;

export default function useInfluencerPlan(influencerPlanId: number | null | undefined, config?: Config) {
    const query = useQuery({ ...options(influencerPlanId), ...config, enabled: !!influencerPlanId && config?.enabled });

    return {
        data: query.data,
        status: query.status,
        error: query.error,
    };
}
